import { useEffect, useRef } from "react"
import { useFormikContext } from "formik"

import { useDirtyForms } from "@/onboarding/features/product/DirtyFormsContext"
import { useWindowUnloadPrevention } from "@/onboarding/features/product/helpers"

const TrackFormDirty = ({ formId }: { formId: string }) => {
  const { dirty } = useFormikContext()
  const { setFormDirty } = useDirtyForms()
  const lastDirtyRef = useRef<boolean | null>(null)

  useWindowUnloadPrevention(dirty)

  useEffect(() => {
    if (lastDirtyRef.current !== dirty) {
      setFormDirty(formId, dirty)
      lastDirtyRef.current = dirty
    }
  }, [dirty, formId, setFormDirty])

  return null
}

export default TrackFormDirty
